/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * FastMile API
 * OpenAPI spec version: v1
 */
import { useMutation } from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'

import type { ApiResponse, OnboardingRequestDto } from '../../models/generated'

import { fastmileInstance } from '../../fastmileInstance'

export const postApiOnboardingOnboardClient = (
  onboardingRequestDto: OnboardingRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<ApiResponse>({
    url: '/api/Onboarding/onboard-client',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: onboardingRequestDto,
    signal,
  })
}

export const getPostApiOnboardingOnboardClientMutationOptions = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOnboardingOnboardClient>>,
    TError,
    { data: OnboardingRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOnboardingOnboardClient>>,
  TError,
  { data: OnboardingRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiOnboardingOnboardClient']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiOnboardingOnboardClient>>,
  { data: OnboardingRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiOnboardingOnboardClient(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiOnboardingOnboardClientMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiOnboardingOnboardClient>>
>
export type PostApiOnboardingOnboardClientMutationBody = OnboardingRequestDto
export type PostApiOnboardingOnboardClientMutationError = ApiResponse

export const usePostApiOnboardingOnboardClient = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOnboardingOnboardClient>>,
    TError,
    { data: OnboardingRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiOnboardingOnboardClient>>,
  TError,
  { data: OnboardingRequestDto },
  TContext
  > => {
  const mutationOptions =
    getPostApiOnboardingOnboardClientMutationOptions(options)

  return useMutation(mutationOptions)
}
